export default {
    testLottie: {
        path: "/auth/test/lottie",
    },
}